<template>
	<div>

		<div class="custom-loader-wrapper" v-if="loader">
			<div class="text-center">
				<span class="d-block max-450">
					We are processing your download and this may take some time. Do not close this window until the download begins.
				</span>
				<img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
				
			</div>
		</div>
		<div class="mt-5 px-0">
			<div class="row px-0">
					<div class="ibox col-md-12 border-0">
						<div class="ibox-title dashboard_title">
							<h4 class="clearfix">
								<span class="float-left">Statements of Member’s PF Account</span>
								<span class="float-right">
									<select id="year" v-model="year" name="year" class="form-control custom-select" v-on:change="setfiscalyear()">
										
										<template v-if="pf_settings.pf_year_end.opt_value != 12"> 
											<option v-for='pyr in payrunyears'  :value='pyr'>{{ pyr }}</option>		
										</template>	
										<template v-else>
											<option v-for='pyr in f_y'  :value='pyr'>{{ pyr }}</option>		
										</template>									
									</select>
								</span>
							</h4>
						</div>
						<div class="ibox-content pf-overview p-0">
							

								<div class="row trz_row_overview ibox no-margin no-shadow border p-0 mt-0">
									
									<template  v-if="employee_info.length == 0">
										<div class="col-lg-12 col-md-12 col-sm-12 ">
											<div class="no-result-cell text-center">
												<img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo pf-statement-overview-loader"/>
											</div>
										</div>
									</template>
									<template v-else>
										<div class="col-lg-6 col-md-6 col-sm-12 px-4 py-4">
											<div class="row">
												<div class="col-lg-6 col-md-6 col-sm-12"><h3>Name</h3></div>
												<div class="col-lg-6 col-md-6 col-sm-12"><span>{{employee_info.employee_name}}</span></div>
											</div>
											<div class="row">
												<div class="col-lg-6 col-md-6 col-sm-12"><h3>Designation</h3></div>
												<div class="col-lg-6 col-md-6 col-sm-12"><span>{{employee_info.jobposition}}</span></div>
											</div>
											<div class="row">
												<div class="col-lg-6 col-md-6 col-sm-12"><h3>Employee ID</h3></div>
												<div class="col-lg-6 col-md-6 col-sm-12"><span>{{employee_info.employee_code}}</span></div>
											</div>
										</div>
										<div class="col-lg-6 col-md-6 col-sm-12 px-4 py-4">
											<div class="row">
												<div class="col-lg-6 col-md-6 col-sm-12"><h3>Date of Joining</h3></div>
												<div class="col-lg-6 col-md-6 col-sm-12"><span>{{employee_info.joining_date}}</span></div>
											</div>
											<div class="row">
												<div class="col-lg-6 col-md-6 col-sm-12"><h3>Membership Date</h3></div>
												<div class="col-lg-6 col-md-6 col-sm-12"><span>{{employee_info.PF_enrollment_date}}</span></div>
											</div>
											<div class="row">
												<div class="col-lg-6 col-md-6 col-sm-12"><h3>Division/Department</h3></div>
												<div class="col-lg-6 col-md-6 col-sm-12"><span>{{employee_info.department}}</span></div> 
											</div>
										</div>
								    </template>
								</div>
							
						</div>
						<div class="ibox-content">
							
							<b-overlay :show="showoverlay_list_statement" class="showoverlay_list_statement" rounded="sm">
							<div class="row">
								<div class="col-lg-12 col-md-12 col-sm-12 cursor-pointer">
									<table class="w-100">
										<thead>
											<tr class="table-head">
												<th scope="col">Particulars</th>
												<th class="text-center" scope="col">Member’s Amount (BDT)</th>
												<th class="text-center" scope="col">Company’s Amount (BDT)*</th>
												<th class="text-center" scope="col">Total Amount (BDT)</th>
											</tr>
										</thead>
										<tbody>
											<template v-if="show_data">
												<tr class="table-row">
													<td class="font-semi-bold">{{ pf_statement_data.opening_text }}</td>
													<td class="text-right font-semi-bold">{{ formatMoney(pf_statement_data.employee.opening) }}</td>
													<td class="text-right font-semi-bold">{{ formatMoney(pf_statement_data.employer.opening) }}</td> 
													<td class="text-right font-semi-bold">{{ formatMoney(pf_statement_data.opening_total) }}</td>
												</tr>
												<tr class="table-row">
													<td>{{ pf_statement_data.contribution_text }}</td>
													<td class="text-right">{{ formatMoney(pf_statement_data.employee.contribution) }}</td>
													<td class="text-right">{{ formatMoney(pf_statement_data.employer.contribution) }}</td>
													<td class="text-right">{{ formatMoney(pf_statement_data.contribution_total) }}</td>
												</tr>
												<tr class="table-row">
													<td>Add: Interest/profit accrued during the year</td>
													<td class="text-right">{{ formatMoney(pf_statement_data.employee.profit) }}</td>
													<td class="text-right">{{ formatMoney(pf_statement_data.employer.profit) }}</td>
													<td class="text-right">{{ formatMoney(pf_statement_data.profit_total) }}</td>
												</tr>
												<tr class="table-row">
													<td>Less: PF Advance Balance</td>
													<td class="text-right">({{ formatMoney(pf_statement_data.employee.loan) }})</td>
													<td class="text-right">({{ formatMoney(pf_statement_data.employer.loan) }})</td>
													<td class="text-right">({{ formatMoney(pf_statement_data.loan_total) }})</td>
												</tr>
												<tr class="table-row">
													<td class="font-semi-bold">{{ pf_statement_data.closing_text }}</td>
													<td class="text-right font-semi-bold">{{ formatMoney(pf_statement_data.employee.closing) }}</td>
													<td class="text-right font-semi-bold">{{ formatMoney(pf_statement_data.employer.closing) }}</td>
													<td class="text-right font-semi-bold">{{ formatMoney(pf_statement_data.closing_total) }}</td>
												</tr>
											</template>
											
																		
										</tbody>
									</table>

	

									<table>
										<tbody>
											<tr>
												<td style="height:40px; text-align:justify; padding-left: 0; font-weight: 600; font-size: 12px;">Note: The figures appearing in this statement have been rounded off to nearest BDT.</td>
											</tr>
											<tr>
												<td>&nbsp;</td>
											</tr>
											<tr>
												<td style="text-align:justify; padding-left: 0; font-weight: 600; font-size: 12px;">* Eligibility of Company’s Contribution and its interest/profit is as per PF Trust rules which is as follows:</td>
											</tr>
										</tbody>
									</table>


						
									<table border="1" style="margin-top:0; border-collapse: collapse; width: 573px;border:none; border-spacing: 0 50px;">
										<thead>
											<tr class="table-head">
												<th style="width: 56%; background: #E1EBF8; color: #212529;">Length of Continuous Service</th>
												<th style="width: 44%; background: #E1EBF8; color: #212529;">Company’s Contribution + Interest</th>
											</tr>
										</thead>
										<tbody>
											<tr class="table-row">
												<td style="font-size: 10px; border-right: 1px solid #E8E8E8;">If employment period is equal or more than 24 months and membership of the fund for 12 months</td>
												<td style="font-size: 10px; text-align: center;">100%</td>
											</tr>
											<tr class="table-row">
												<td style="font-size: 10px; border-right: 1px solid #E8E8E8;">If the above conditions are not fulfilled</td>
												<td style="font-size: 10px; text-align: center;">0%</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div class="col-lg-12 col-md-12 col-sm-12 cursor-pointer text-right">
									<b-button class="mt-5" @click="showStatementDownloadForm()">
										Download PF Statement
									</b-button>
								</div>
							</div>
							</b-overlay>

							
						</div>
					</div>
					
		
			</div>
		</div>
		<b-modal id="bv-modal-process-statement" size="md" hide-footer  title="Download PF Statement">
            <pf-statement-download-form :employee_info="employee_info" :key="waiver_key" :pageurl="pageurl" :store_scope="store_scope"  v-on:childToParent="statementReturn"></pf-statement-download-form>
        </b-modal>

	</div>
</template>
<script> 
  
    import moment from 'moment';
    export default{
      mounted() {
            this.$refs.trzcalendar;
        },

        props: ['pageurl' , 'addons'],
        components: {
        },
        data(){

            return {
               activateKey: 0,
               pageUrl : this.$api_url,
			   showoverlay_h:true,
			   show_data:false,
               public_info : [],
               avatarsrc : '',
               avatarsrc1 : '',                
               company_avatarsrc1 : '',      
               img_src : this.$api_url+'/images/employee_dasboard/', 
               cr : 0, 
               this_month : 1,
               this_year : 2020,
               weekly_holidays : [6],
               first_day_of_week : 7,
               this_month_holidays : [],
               week_holidays : [6],
               all_week_holidays : [6],
               holidays_date_arr : [],
			   report_data:[],
			   employee_info:[],
			   details:[],
               header_year_month : '',
               start_date: null,
               end_date: null,
               total_working_day : 0,
               total_weekends : 0,
               total_holidays : 0,
               total_absent : 0,
               total_leaves : 0,
               page: { month: '', year: '' }, 
			   company_access_settings:{},  
			   payrunyears: [], 
			   f_y:[],
			   pf_statement_data:[],
			   loader:false,
			   year: '', 
			   selected:[],
			   download_text:'',
			   showoverlay_list_statement:true,
			   waiver_key:0,
			   store_scope:'front',
			   pf_settings :{pf_profit_waive_feature:{ opt_value: 0, status: 0 },pf_year_end:{ opt_value: 0, status: 0 },},
			   attributes: [
					{
						key: 'today',
						highlight: {
							style: {                     // Circle styles
								background: '#5533FF'
							},
							contentStyle: {              // Text styles
								color: 'white'
							},
							contentClass: 'date-text-today',
							class: 'date-circle-today',
						},
						dates: new Date(),
					}
				],
            }
        },
        methods:{
            monthDetails: function(x='' , y=0, m=0)
            {                
               let currentObj = this;
               let year = 0;
               let month = 0;
               
               if(y == 0)    
               {
                  year = x['year'];
                  month = x['month'];
               }   
               else
               {
                  year = y;
                  month = m;
               }     
                  
               let st_date = new Date(year , month - 1 , 1);
               let en_date = new Date(year , month , 0);   

               
               this.start_date = moment(String(st_date)).format('Do MMMM YYYY');
               this.end_date = moment(String(en_date)).format('Do MMMM YYYY');
               
            

                  // fetch holidays dynamically from controller
            
            },
            updateActivityLog: function(data)
            {
               this.activateKey = this.activateKey+1;
               
            },

			downloadCertificate(id,mod_flag,flag = 0 , file_only = 0)
            {
              

                	this.selected.push(id);

                    
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                   
                    let formData = new FormData();
                    formData.append('employee_ids', this.selected);
                    formData.append('fiscal_year', this.year);
                    formData.append('modification_flag', mod_flag);
                    formData.append('from_month', '');
                    formData.append('to_month', ''); 
                    formData.append('flag', flag);
                    formData.append('file_only', file_only);
                    
                    var modification_flag =mod_flag;

                    currentObj.loader = true;

					currentObj.download_text = 'We are processing your download and this may take some time based on the number of files you are downloading. Do not close this window until the download begins.';                    
					
					axios.post(this.$api_url+'/templates/downloadmultipletemplate', formData, config)
					.then(function (response) {
						
						currentObj.showoverlay_h = false;
						var fname=response.data.file_name;
						if(response.data.download_file_name)
							var download_f_name =   response.data.download_file_name;
						else
							var download_f_name =   fname; 
						if(download_f_name){  
							window.location.href = currentObj.$api_url+'/templates/downloadzip?file_name='+fname+'&download_file_name='+download_f_name+'&modification_flag='+modification_flag;    
						
							//console.log(currentObj.$api_url+'/templates/downloadzip?file_name='+fname+'&download_file_name='+download_f_name+'&modification_flag='+modification_flag);
						}
						
						if(response.data.errors)
						{
							
							var errors = response.data.errors;
							errors.replace("<br>", "</br>");
							currentObj.$bvToast.toast(response.data.errors, {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});

						}
						
						currentObj.loader = false;  
						currentObj.download_text = ''; 
						
						})
						.catch(function (error) {
							
							currentObj.loader = false;
							currentObj.download_text = '';
							
						});
                    
                    
                                             
              },

            

            getEmployeePublicData: function()
            {
               if(!this.checkNet()) return false;
               axios.get(this.$api_url+'/employee/publicinfo' , {
                  params: {
                     
                  }
               }).then(function(response){
                  if(response.data)
                  {
                     this.company_assigned = true;
                     this.public_info = response.data;
                     

                     if(this.public_info.pic != '')
                           this.avatarsrc = this.$api_url+'/images/employee/'+ this.public_info.company_id + '/' + this.public_info.pic;
                     else
                           this.avatarsrc = this.$api_url+'/images/employee/demo.jpg';
                     if(this.public_info.logo != '')//at_edit
                           this.company_avatarsrc1 = this.$api_url+'/images/company/' + this.public_info.logo;//at_edit
                     else
                           this.company_avatarsrc1 = this.$api_url+'/images/company/demo.jpg';

                     if(this.public_info.report_to_pic != '')
                           this.avatarsrc1 = this.$api_url+'/images/employee/'+ this.public_info.company_id + '/' + this.public_info.logo; //at_edit
                     else
                           this.avatarsrc1 = this.$api_url+'/images/employee/demo.jpg';

                  }
                  else
                  {
                     this.company_assigned = false;
                     this.no_company_message = 'As soon as you are associated with any company, you will be able to see all data accordingly!';
                  }

                  
                  
               }.bind(this));
         	},
			setMe :function(x)
			{
				
				
				if(x == 'request-leave')            
				this.$bvModal.show('bv-modal-leave');
				else
				{
				
				let childdata = {component_name:x};                    
				this.$emit('childToParent', childdata);
				}
				
			},
			reloadMe : function()
			{
				this.$bvModal.hide('bv-modal-leave');
			},
		 	get_access_settings: function()
            {
                // 
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/employee-access-settings' , {
                }).then(function(response){

                    let company_access_settings_temp = {};
                    company_access_settings_temp = response.data;
                    
                    for (const [key, value] of Object.entries(company_access_settings_temp)) {
                        
                            if(value==1)
                            {
                                company_access_settings_temp[key] = true;
                            }
                            else
                            {
                                company_access_settings_temp[key] = false;
                            }

                            }

                    this.company_access_settings = company_access_settings_temp;

                }.bind(this));
            },

			getpayrunyears: function()
			{

						axios.get(this.$api_url+'/getpayrun-years' , {
							params: {
								page: 1,
								per_page: 10,
								search_query: this.search,
								search_query_by_id: '',
							}
					}).then(function(response){
					this.payrunyears = response.data;
					
					console.log(this.payrunyears[0].range);


				}.bind(this));
			},
			get_current_fiscal_year: function()
            {
                // 
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/getcurrentfiscalyear' , {
                }).then(function(response){
                    this.year= response.data;
                    
                }.bind(this));
            },
			setfiscalyear: function()
			{
				this.getPFStatement(this.year);
			},
			getPFStatement: function(year)
			{
				let currentObj = this;
				let formData = new FormData();
				formData.append('employee_id', this.employee_info.employee_id);
				formData.append('fiscal_year', year);
				formData.append('modification_flag',14);

				//currentObj.download_loader = true;

				axios.post(this.$api_url+'/pf/report/statement', formData)
				.then(function (response) {                            
											
						currentObj.showoverlay_h = false;
						currentObj.pf_statement_data = response.data;
						currentObj.show_data = true;
						currentObj.showoverlay_list_statement = false;
						
						// currentObj.download_loader = false;  
						// currentObj.download_text = ''; 
						
					})
					.catch(function (error) {
						// currentObj.output = error;
						// currentObj.download_loader = false;
						// currentObj.showoverlay_h = false;
						// currentObj.download_text = '';
					});
                    
			
			},
			pfDetailsNew: function()
            { 
                
                let currentObj = this;
                
                let formData = new FormData();
                
                formData.append('viewmode', 1);
                formData.append('d_type', 'excel'); 
                formData.append('data_front', 'yes'); 
                this.pfoverlay = true;
                this.report_data = [];
                this.details = [];
                this.employee_info = [];

                //currentObj.showoverlay = true;
                
                axios.post(this.$api_url + '/pf/report/profile', formData)
                                    .then(function (response) 
                                    {
                                        
                                        this.employee_info = response.data.file_name.employee_info;
                                        this.details = response.data.file_name.data;
										// alert('asd');
                                        // console.log(this.employee_info);
                                        // console.log(this.details);
                                        //currentObj.showoverlay = false;
                                        this.pfoverlay = true;
										this.getEmployeeActiveYearlist(this.employee_info.employee_id);
										this.getPFStatement(this.year);
                                    }.bind(this))
                                    .catch(function (error) 
                                    {
                                        //currentObj.showoverlay = false;
                                        console.log(error);
                                    }); 

                    
							
                    this.$bvModal.show('bv-modal-pf-details');

            }, 
			formatMoney: function(amount)
            {
                var money = Number(amount);

                if(this.$atl_company_number_format == 'no')
                {
                    money = Math.round(money);
                    money = money.toLocaleString();
                }
                else
                {
                    money = money.toLocaleString();
                    if(money=='NaN')
                    money = amount;
                    else{
                    if(money.indexOf(".")<0)
                    money = money+".00";
                    }

                }
                
                return money;
            }, 
           toMoney: function(amount)
            {
                if(amount !="0")
                {
                        if(!isNaN(amount))
                        {
                            var number = Number(amount);
                            return number;
                        }
                    var NumWithoutCommas = amount.replace(/,/g, ''); 
                    var number = Number(NumWithoutCommas).toFixed(2);
                    return number;
                }else
                    return amount;
            },
			showStatementDownloadForm: function()
            {
                this.waiver_key += 1;
                this.showStatementForm = true;
                this.$bvModal.show('bv-modal-process-statement');
            },
			statementReturn()
            {
                this.showStatementForm = true;
                this.$bvModal.hide('bv-modal-process-statement');
            },
			getEmployeeActiveYearlist:function(employee_id)
            {        
                 
                if(!this.checkNet()) return false;

				let formData = new FormData();
                
                formData.append('employee_id', employee_id);

                //currentObj.showoverlay = true;
                
                axios.post(this.$api_url + '/pf/employee/active-year-list', formData)
				.then(function (response) 
				{
                        this.respData = response.data;
                        
                        if(this.respData.fiscal_year.length > 0) 
                        {
                            this.payrunyears = this.respData.fiscal_year;
                            this.f_y = this.respData.year;
							if(this.pf_settings.pf_year_end.opt_value != 12)
							{
								this.year= this.payrunyears[0];
							}
							else
							{
								this.year= this.f_y[0];
							}
							this.getPFStatement(this.year);
                        }
                        else
                        {
                            this.statememt_available = false;
                        }
                        this.showoverlay = false;
                        
                    }.bind(this)).catch(function (error){alert(error)});
               
            },   
			getPFSettings: function()
            { 
                
                let currentObj = this;
                axios.get(this.$api_url+'/pf/settings').then(function (response) {
                    currentObj.pf_settings = response.data.data;
                   
                        
                })  
                .catch(function (error) {
                console.log(error);
                });
                
            },
            
            
        },
        created: function(){
			this.getPFSettings();
			this.pfDetailsNew();
            this.getEmployeePublicData();
			this.get_access_settings();
			//this.getpayrunyears();
			this.get_current_fiscal_year();
            // var m = check.format('M');
            // var y  = check.format('YYYY');
            // this.monthDetails('',y,m);
            // this.page = { month: m, year: y };
         
        },
 
    }

</script>
